<template>
    <div class="h-full w-[95%] lg:w-1/2 flex justify-center items-center">
        <div class="w-full lg:w-1/2 bg-white rounded-3xl shadow relative" :class="{ ' font-arabic': locale === 'ar' }">

            <!-- Header -->
            <div :class="[
                'text-white w-full py-5 text-lg bg-gradient-to-br from-gifty-pink to-gifty-pink_dark rounded-t-3xl flex justify-center items-center text-center font-extrabold',
                locale === 'ar' ? ' font-arabic' : ''
            ]">
                {{ $t('register.registration_form') }}
            </div>

            <!-- Body -->
            <div class="w-full grid grid-cols-1 gap-5">
                <!-- Stepper -->
                <Stepper_container />

                <!-- Description -->
                <div :class="['text font-medium text-[#313472] mt-4 px-5', locale === 'ar' ? ' font-arabic' : '']">
                    {{ $t('register.phone_step_description') }}
                </div>

                <!-- Phone input -->
                <div class="w-full px-5">
                    <div :class="[' text-sm text-slate-600 mb-2 block', locale === 'ar' ? ' font-arabic ' : '']">
                        {{ $t('register.phone_number') }}
                    </div>

                    <div>
                        <input v-model="phone" @input="handlePhoneInput" :class="[
                            'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none transition duration-300 px-3 py-3   mx-auto cursor-pointer mb-3  ',
                            locale === 'ar' ? ' font-arabic' : '',
                            phoneError
                                ? 'border-red-500 focus:border-red-500'
                                : 'border-slate-200 focus:border-gifty-pink focus:border-2'
                        ]" type="text" placeholder="Ex: 0770770000" maxlength="10" />

                        <p v-if="phoneError" class="text-sm text-red-500 mt-1"
                            :class="{ ' font-arabic': locale === 'ar' }">
                            {{ $t('register.errors.phone') }}
                        </p>
                    </div>
                </div>

                <!-- Submit button -->
                  
                <div @click="submitPhone" :class="[
                    'text-sm w-fit rounded-lg font-bold px-3 py-2 text-center mx-auto transition duration-200 cursor-pointer mb-3',
                    locale === 'ar' ? ' font-arabic' : '',
                    isValidPhone
                        ? 'bg-gradient-to-br from-gifty-pink to-gifty-pink_dark text-white hover:bg-[#a32b45]'
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                ]">
                    {{ $t('register.verify_phone_number') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Stepper_container from '@/components/stepper_container.vue';
import { useRegistrationStore } from '@/stores/registrationStore'
import { ref, computed, defineEmits, onMounted } from 'vue'
import { useRouter } from 'vue-router';

import { useI18n } from 'vue-i18n'
const { locale } = useI18n()

const registerStore = useRegistrationStore();
const phone = ref('')
const phoneError = ref(false)
const router = useRouter()


const handlePhoneInput = (e) => {
    phone.value = e.target.value.replace(/\D/g, '')
}

const isValidPhone = computed(() => /^0[567]\d{8}$/.test(phone.value));

const submitPhone = async () => {

    if (!isValidPhone.value) {
        phoneError.value = true
        return
    }

    phoneError.value = false
    emit('toggleLoading', true);

    let formatedPhone = formatPhoneNumber(phone.value);

    let response = await registerStore.sendOtpRequest(formatedPhone);

    if (response.success) {
        registerStore.goToVerification(response.data);
        router.push({ name: 'verification' });

    } else {
        if(! response.message){
            phoneError.value = true;

        }else{
            emit('toggleMessageModal', true, false, response.message, "phone");
        }
        // phoneError.value = true;
    }

    emit('toggleLoading', false);
    return;

}

const formatPhoneNumber = (phone) => {
    let cleaned = String(phone).trim();
    cleaned = cleaned.replace(/\D/g, '');

    if (cleaned.startsWith('0')) {
        cleaned = cleaned.substring(1);
    }

    if (!cleaned.startsWith('213')) {
        cleaned = '+213' + cleaned;
    } else {
        cleaned = '+' + cleaned;
    }

    return cleaned;
}

const emit = defineEmits(['toggleLoading' ,'toggleMessageModal'])


onMounted(() => {
    localStorage.removeItem("auth_token");
})
</script>
